
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorPistonOpen as ObiTwowayAcuatorPistonOpenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-piston-open.js';
 
 
 

 
 export const ObiTwowayAcuatorPistonOpen = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-piston-open',
   elementClass: ObiTwowayAcuatorPistonOpenElement,
   events: {
     
   }
  });
 
 